<div class="home_page" id="HomeSection">
    <app-header></app-header>
    <!-- <div class="row">
        <div class="col-7 home_content_wrap">
           <div class="welcome_header">
            Welcome To Sharkify AI
            <img class="wave_curve" src="/assets/home/home_wave.svg">
           </div>
           <div class="home_survival_brand_text">
                # Boost Your Brand’s Lifeline with Sharkify AI
           </div>
           <div class="header_content_wrapper">
                <div class="header_content_text">
                    At Sharkify, we're masters of startup survival and brand vitality, deploying advanced digital and AI
                    marketing strategies to save and elevate brands on the brink. Connect with us to revitalize your
                    business and lead the future.
                </div>
           </div>
           <div>
                <button class="free_trail_button">
                    Start 7-Day Free Trial
                    <span class="home_curve"></span>
                </button>
           </div>
           <div class="free_trail_button_note_text"> 
                *with zero cost in trial period 
                <img class="orange_curve" src="/assets/home/home_orange.svg">
           </div>
        </div>
        
        <div class="col-5 home_page_image">
            <img src="assets/svg/digital_icon.svg" alt="Digital Icon" class="digital_icon">
        </div>
    </div> -->
    <app-home-component></app-home-component>
    <app-tagline></app-tagline>

    <section id="ExpertsIn">
        <app-experts-in></app-experts-in>
    </section>

    <app-how-it-works></app-how-it-works>
    <section id="SocialMediaPlans">
        <app-social-media-plans></app-social-media-plans>
    </section>
    <section id="Tools">
        <app-more-tools></app-more-tools>
    </section>
    <app-our-mission></app-our-mission>
    

    <!-- <app-business-numbers></app-business-numbers> -->
    <!-- <section id="BrandingPlans">
    <app-branding-plans></app-branding-plans>
</section> -->
    <!-- <app-our-moto></app-our-moto> -->
    <!-- <section id="ContactUs">
        <app-contact-us></app-contact-us>
    </section> -->
    <app-footer></app-footer>